import axios from 'axios';
import { BASE, getHeaders } from './config';

export function getTruckTypes() {
    return axios.get(`${BASE}/truck-types`, { headers: getHeaders() });
}